import { AlertCircle, Upload } from "lucide-react";

/** Red inline badge for documents whose presigned upload never finalised.
 *  Pass `onRetry` to render it as a one-click "Upload again" button. */
export const UploadFailedBadge = ({ doc, onRetry, className = "" }) => {
  if (doc?.upload_status !== "failed") return null;
  const title = doc.upload_error || "Upload didn't complete — please upload this file again.";
  const base = "inline-flex shrink-0 items-center gap-1 rounded-full bg-red-50 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-red-700 ring-1 ring-red-200 ";
  if (onRetry) {
    return (
      <button type="button" onClick={onRetry} title={title}
        data-testid={`upload-failed-${doc.doc_id}`}
        className={base + "cursor-pointer transition-colors hover:bg-red-100 hover:ring-red-300 " + className}>
        <AlertCircle className="h-2.5 w-2.5" /> Upload didn&apos;t complete
        <span className="ml-0.5 inline-flex items-center gap-0.5 rounded-full bg-red-600 px-1.5 py-px text-white">
          <Upload className="h-2.5 w-2.5" /> Upload again
        </span>
      </button>
    );
  }
  return (
    <span data-testid={`upload-failed-${doc.doc_id}`} title={title} className={base + className}>
      <AlertCircle className="h-2.5 w-2.5" /> Upload didn&apos;t complete — re-upload
    </span>
  );
};
